import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { monitoringService } from '../services/monitoringService';
import toast from 'react-hot-toast';

interface ShareButtonProps {
  title?: string;
  text?: string;
  url?: string;
  className?: string;
  onShareComplete?: () => void;
}

export default function ShareButton({
  title = 'Kariera z AI - Twój Doradca Kariery',
  text = 'Odkryj swoją idealną ścieżkę kariery z pomocą sztucznej inteligencji!',
  url = 'https://karierazai.pl',
  className = '',
  onShareComplete
}: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    try {
      // Check if running on mobile
      if (navigator.share && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        // Use native sharing on mobile
        await navigator.share({
          title,
          text,
          url
        });
        monitoringService.trackUserBehavior('content_shared', {
          method: 'native_share', // Corrected key
          platform: 'mobile'
        });
        if (onShareComplete) onShareComplete();
        return;
      }

      // Fallback to clipboard on desktop
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Link skopiowany do schowka!', {
        icon: '🔗',
        duration: 2000,
        position: 'bottom-center'
      });
      monitoringService.trackUserBehavior('content_shared', {
        method: 'clipboard', // Corrected key
        platform: 'desktop'
      });
      if (onShareComplete) onShareComplete();

      // Reset copied state after animation
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      if (err instanceof Error && err.name !== 'AbortError') {
        toast.error('Nie udało się udostępnić');
        monitoringService.trackError(err, {
          action: 'share_content'
        });
      }
    }
  };

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleShare}
      className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors ${className}`}
    >
      <Share2 className="w-4 h-4" />
      {copied ? 'Skopiowano!' : 'Udostępnij'}
    </motion.button>
  );
}
